interface IsCompanyNameDefaultProps {
  companyName?: string
  userEmail?: string
}

export function isCompanyNameDefault({ companyName, userEmail }: IsCompanyNameDefaultProps): boolean {
  const isLowercase = companyName === companyName?.toLowerCase()
  const isDefault = companyName === userEmail?.split('@')[0]

  return isDefault && isLowercase
}
